import { render, staticRenderFns } from "./sub_alfx_detail.vue?vue&type=template&id=7ce61ba0&scoped=true"
import script from "./sub_alfx_detail.vue?vue&type=script&lang=js"
export * from "./sub_alfx_detail.vue?vue&type=script&lang=js"
import style0 from "./sub_alfx_detail.vue?vue&type=style&index=0&id=7ce61ba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce61ba0",
  null
  
)

export default component.exports